import {
    Pipe, PipeTransform
} from "@angular/core";

/**
 * Use this pipe instead of the hotkey pipe that comes with ngNeat
 *
 * This will display the hotkey in a way our users are used to.
 */
@Pipe({ name: "mgdHotkey" })
export class MgdHotkeyPipe implements PipeTransform {

    transform(value: string): unknown {
        if (!value) {
            return "";
        }
        // Replace the '.' separator with a '+'
        value = value.replace(/\./g, "+");
        // The meta key is cmd in Mac OS X and ctrl in all other OSes
        let meta = "ctrl";
        if (window?.navigator?.userAgent?.match(/Mac OS X/)) {
            meta = "cmd";
        }
        value = value.replace("meta", meta);
        return value;
    }

}
